"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Model_1 = require("../Model");
const MediaQueryExceptions_1 = require("./MediaQueryExceptions");
class MediaQuery extends Model_1.default {
    /**
     *
     * @param {Types.MediaQuery.Breakpoints} [breakpoints]
     * @memberof MediaQuery
     */
    constructor(breakpoints) {
        super();
        /**
         *
         *
         * @protected
         * @type {Array<string>}
         * @memberof MediaQuery
         */
        this.exportableProperties = ['breakpoints'];
        this.breakpoints = breakpoints || {};
        Object.keys(this.breakpoints).forEach(key => {
            Object.defineProperty(this, key, {
                enumerable: false, configurable: false, writable: false, value: (css) => this.get(key, css)
            });
        });
    }
    /**
     *
     *
     * @param {string} name
     * @param {*} [css=null]
     * @returns {string}
     * @memberof MediaQuery
     */
    get(name, css = null) {
        const breakpointsSlug = Object.keys(this.breakpoints);
        for (let i = breakpointsSlug.length - 1; i >= 0; i--)
            if (breakpointsSlug[i] == name)
                return css ? this.toCSS(this.breakpoints[breakpointsSlug[i]], css) : this.breakpoints[breakpointsSlug[i]];
        throw new MediaQueryExceptions_1.MediaQueryNotFoundException(name);
    }
    /**
     *
     *
     * @private
     * @param {string} mediaQuery
     * @param {*} css
     * @returns {string}
     * @memberof MediaQuery
     */
    toCSS(mediaQuery, css) {
        return `@media ${mediaQuery} { ${css} }`;
    }
}
exports.default = MediaQuery;
//# sourceMappingURL=MediaQuery.js.map